import { Component } from "react";

class Header extends Component {
    render() {
        return this.props.globalStore.appBar;
    }
}

export default Header;
